module.exports = __webpack_public_path__ + "img/prize-01-pic.25302b60.png";